import React, { useState } from "react";

const Upload = ({ text, onFileUpload }) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [fileName, setFileName] = useState(null);
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const allowedTypes = [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (!allowedTypes.includes(file.type)) {
        alert("Only Word documents are allowed.");
        return;
      }

      setFileName(file.name); // Store the uploaded file name
      setUploadProgress(0); // Reset progress for new file upload

      // Simulate upload progress (optional)
      simulateUpload();

      // Call the onFileUpload function passed as a prop
      if (onFileUpload) {
        const response = await onFileUpload(file); // Pass the file to the API
      }
    }
  };

  const simulateUpload = () => {
    const interval = setInterval(() => {
      setUploadProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prevProgress + 5;
      });
    }, 50); // Simulate smooth progress
  };

  const handleRemoveFile = () => {
    setFileName(null);
    setUploadProgress(0);
  };

  return (
    <>
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 md:p-14 flex items-center justify-center cursor-pointer hover:bg-gray-50">
        <label
          htmlFor="file-upload"
          className="text-lg md:text-2xl font-bold text-gray-500 hover:text-blue-500 underline cursor-pointer text-wrap"
        >
          {text}
        </label>
        <input
          id="file-upload"
          type="file"
          className="hidden"
          accept=".doc,.docx" // Restrict to Word document file extensions
          onChange={handleFileUpload}
        />
      </div>

      {fileName && (
        <div className="mt-4 flex items-center justify-between bg-gray-100 p-2 rounded-lg">
          <span className="text-gray-800">{fileName}</span>
          <button
            onClick={handleRemoveFile}
            className="text-red-500 hover:text-red-700"
          >
            &#10005; {/* Cross (×) symbol */}
          </button>
        </div>
      )}

      <div className="mt-2 w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-blue-600 text-xs leading-none text-center text-white rounded-full h-2 transition-all duration-300"
          style={{ width: `${uploadProgress}%` }}
        ></div>
      </div>
    </>
  );
};

export default Upload;
